import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import ManageBuyerParent from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import Translate from "../../utils/utils";

const headCells = [

    {id: 'rfh_number', numeric: true, disablePadding: false, label: <Translate id={"TABLE.RFH_NUMBER"}/>},
    {id: 'name', numeric: false, disablePadding: false, label: <Translate id={"TABLE.NAME"}/>},
    {id: 'phone', numeric: true, disablePadding: false, label: <Translate id={"TABLE.PHONE"}/>},
    {id: 'contact', numeric: true, disablePadding: false, label: <Translate id={"TABLE.CONTACT"}/>},
    {id: 'date', numeric: true, disablePadding: false, label: <Translate id={"TABLE.DATE"}/>},
    {id: 'actions', numeric: true, disablePadding: false, label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function BuyerParentList(props) {
    const user = useSelector(store => store.auth.user);
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;;
    const [buyerParents, setBuyerParents] = useState([]);
    const initialValues = {name: "", email: "", phone: "", rfh_number: '', contact: ''};
    const [buyerParent, setBuyerParent] = useState(initialValues);
    const resource = new Resource('buyerParent');
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(true);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: queryParams.page,
        per_page: queryParams.perPage,
    });
    const moduleName = <Translate id={"MENU.BUYER_PARENTS"}/>;

    const removeItemInListing = (id) => {
        const remaining = buyerParents.filter((item) => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setBuyerParents(remaining);
    };

    useEffect(() => {
        const index = () => {
            setIsLoading(true);
            const resource = new Resource('buyerParent');
            resource.index({
                perPage,
                page,
                name: name
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setBuyerParents(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            })
        };
        index();
    }, [page, perPage]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`/buyer/parents?page=${page}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handleCreate = (buyer) => {
        const buyersList = [buyer, ...buyerParents];
        setBuyerParents(buyersList);
    };

    const handleUpdate = (parent) => {
        const buyerParentList = buyerParents.map(item => {
            if (item.id === parent.id) {
                return parent;
            }
            return item;
        });
        setBuyerParents(buyerParentList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };


    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <ManageBuyerParent handleCreate={handleCreate} resource={resource} handleUpdate={handleUpdate}
                                   onCloseModal={() => setBuyerParent(initialValues)} initialValues={buyerParent}
                                   key={buyerParent.id}/>
            </div>

            <Search onType={onType} onSubmit={onSearch} module={moduleName}
                    onClear={onClearSearch} value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            headCells={headCells}
                            rowCount={buyerParents.length}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {buyerParents.map(buyerParent => {

                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={buyerParent.selected}
                                        tabIndex={-1}
                                        key={buyerParent.id}
                                        selected={buyerParent.selected}
                                    >
                                        <TableCell>{buyerParent.rfh_number}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {buyerParent.name}
                                        </TableCell>
                                        <TableCell>{buyerParent.phone}</TableCell>
                                        <TableCell>{buyerParent.contact}</TableCell>
                                        <TableCell>{buyerParent.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete'
                                                    onClick={() => setBuyerParent(buyerParent)}>
                                                {<Translate id={"TABLE.ACTIONS.EDIT"}/>}
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`buyerParent`}
                                                    itemId={buyerParent.id}
                                                    itemName={buyerParent.name}
                                                    removeItemInListing={removeItemInListing}
                                                    dropdownItem={true}
                                                />
                                            </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
